import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import style from './Filter.module.css'

const Filter = () => {
  const { t } = useTranslation()
  return (
    <Box className={style.filter}>
      <p>{t('placeholder.filtersAvailable')}</p>
    </Box>
  )
}

export default Filter
